module.exports = __webpack_public_path__ + "img/logo-ailem.70854f86.jpg";